import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(value: any, ...input: any[]): any {
   
    const term = input[0];
    const fieldName = input[1];

    

      if(term.length > 0){

        //gelen degerin bir de attribute'i olmalid. 
        //Tek boyutlu arraylar'da hata verecektir.
        const filteredItems = value.filter(x => x[fieldName].toLowerCase().includes(term.toLowerCase()));

        console.log("Filtered", filteredItems);
        return filteredItems ;
      }
      else{
        return value;
      }
     
   
    
  }

}
